import { Controller } from "@hotwired/stimulus";
import { get } from '@rails/request.js';

// Connects to data-controller="search-pacientes"
export default class extends Controller {
  static targets = ['searchInput', 'allCheckbox', 'sector', 'obraSocial', 'tipo', 'desde', 'hasta'];
  static values = {
    url: String
  }

  onClickPerformSearch(event) {
    event.preventDefault();
    let sectorValue = null;
    let obraSocialValue = null;
    let tipoValue = null;

    if (this.tipoTarget.value && this.tipoTarget.value !== 'Tipo') {
      tipoValue = this.tipoTarget.value;
    }

    if (this.sectorTarget.value && this.sectorTarget.value !== 'Sector') {
      sectorValue = this.sectorTarget.value;
    }

    if (this.obraSocialTarget.value && this.obraSocialTarget.value !== 'Obra social') {
      obraSocialValue = this.obraSocialTarget.value;
    }

    get(this.urlValue, {
      responseKind: 'turbo-stream',
      query: {
        q: this.searchInputTarget.value || null,
        all: this.allCheckboxTarget.checked,
        sector: sectorValue,
        obra_social: obraSocialValue,
        tipo: tipoValue,
        desde: this.desdeTarget.value || null,
        hasta: this.hastaTarget.value || null
      }
    })
  }
}
